import React from "react"
import { Box, Button, Stack, TextField, Typography } from "@mui/material"

export const LabeledField = ({
  label,
  value,
  onChange,
  error,
  helperText,
  ...textFieldProps
}: {
  label: string
  value: string
  error?: boolean
  helperText?: string
} & React.ComponentProps<typeof TextField>) => {
  const suffix = label.endsWith(" *") ? " *" : ""
  const mainLabel = suffix ? label.slice(0, -suffix.length) : label
  return (
  <Stack spacing={0.5}>
    <Typography
      variant="h6"
      component="span"
      sx={{
        fontSize: "16px",
        lineHeight: "20px",
        fontWeight: 400,
        display: "flex",
        minWidth: 0
      }}
    >
      <Box
        component="span"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          minWidth: 0
        }}
      >
        {mainLabel}
      </Box>
      {suffix ? <Box component="span" sx={{ flexShrink: 0 }}>{suffix}</Box> : null}
    </Typography>
    <TextField
      fullWidth
      size="small"
      value={value}
      onChange={onChange}
      error={error}
      helperText={helperText}
      InputProps={{ readOnly: !onChange }}
      {...textFieldProps}
    />
  </Stack>
  )
}

export const SectionHeader = ({
  title,
  onEdit,
  editDisabled
}: {
  title: string
  onEdit?: () => void
  editDisabled?: boolean
}) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
    <Typography variant="subtitle1" fontWeight="bold" sx={{ fontSize: "21px", lineHeight: "25px", fontWeight: 600 }}>
      {title}
    </Typography>
    {onEdit && (
      <Button
        variant="outlined"
        color="secondary"
        size="small"
        onClick={onEdit}
        disabled={editDisabled}
      >
        Update
      </Button>
    )}
  </Stack>
)
